import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, retry } from 'rxjs';
import { Constants } from '../constant';
import { Batch } from '../models/batch';
import { Common } from '../../shared/common';

@Injectable()
export class BatchService {

  constructor(private http: HttpClient) { }

  getAllBatch(campus: string = 'MAIN') {
    return this.http.get<Batch>(Constants.getApiEndpoint() + '/batch_master/all', Common.campusHeader(campus));
  }

  getBatchList(pgIndex: number, pageSize: number) {
    return this.http.get<Batch>(Constants.getApiEndpoint() + '/batch_master?page=' + pgIndex + "&size=" + pageSize)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getBatch(id: string) {
    if (id === "new") {
      return Observable.of(this.initializeBatch());
    };
    return this.http.get<Batch>(Constants.getApiEndpoint() + '/batch_master/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  deleteBatchMaster(id: string) {
    return this.http.delete<Batch>(Constants.getApiEndpoint() + '/batch_master/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  saveBatchMaster(batch: Batch) {
    if (batch.id === null) {
      return this.createBatchMaster(batch);
    }
    return this.updateBatchMaster(batch);
  }

  private createBatchMaster(batch: Batch) {
    return this.http.post<Batch>(Constants.getApiEndpoint() + '/batch_master', JSON.stringify(batch), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  private updateBatchMaster(batch: Batch) {
    return this.http.post<Batch>(Constants.getApiEndpoint() + '/batch_master', JSON.stringify(batch), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  initializeBatch(): Batch {
    // Return an initialized object
    return {
      id: "",
      batchName: "",
      student_count: 0,
      active: false
    };
  }
}
